export default __webpack_public_path__ + "static/media/IMG_6903.f22752be.jpeg";